historyModule.classy.controller({
    name: 'HistoryController',
    inject: ['$scope', '$http', 'HistoryDataModelService', 'ApplicationService', 'AddHistoryService', 'SchoolTaxModelService'],
    init: function() {
        var parent = this;
        this.$.ApplicationService = this.ApplicationService;
        this.$.AddHistoryService = this.AddHistoryService;
        this.$.HistoryDataModelService = this.HistoryDataModelService;
        this.$.taxinfo = this.ApplicationService.getFamilyData().familyTax[0];
        this.$.dataLoaded = false;
        this.$.familyNo = this.ApplicationService.getFamilyNo();
        this.loadData();
        
    },
    openAddModal: function(items, index) {
        var parent = this;
        this.$.dataLoaded = false;
        this.$.AddHistoryService.initModal(items, index).result.then(
        function(res) {
            parent.loadData();
        },
        function() {
            parent.$.dataLoaded = true;
        });
    },
    loadData: function() {
        let apipath = "/api/family/" + this.ApplicationService.getFamilyData().data[0].familyID + "/historyData";
        this.$http.get(apipath).then((results) => {
            this.$.data = results.data;
            this.$.dataLoaded = true;
        });
    },
    calcPreFastActAward: function(values)
    {
        var sum = 0;
        angular.forEach(values, function(value, key) {
            sum += parseInt(value.ActAward);
        });
        return sum.toString().addCommas();
    }
});
